<template>
  <div
    id="ChatDetailPage"
    class="ChatDetailPage"
    :style="agent_bg"
    v-if="agentInfo"
  >
    <div class="topLimitHint">
      <span
        class="gray"
        v-if="calculateChatLimit.show"
        :class="{ red: calculateChatLimit.color == 'red' }"
        >{{ calculateChatLimit.text }}</span
      >
      <span class="gray2" v-if="calculateChatLimit.show">｜</span>
      <span class="gray">内容由AI生成</span>
    </div>
    <!-- 正文 -->
    <div class="mainBody">
      <div
        class="conversationList"
        ref="conversationList"
        @touchmove="stopAutoScroll"
        @click="stopAutoScroll"
        @scroll="contentOnScroll"
      >
        <van-pull-refresh
          v-show="!showNewChat"
          v-model="chatContentLoading"
          @refresh="getHistoryMessageDetail"
          :disabled="!chatContentHasMore"
        >
          <div class="conversationContent" ref="conversationContent">
            <!-- 开场白 -->
            <div
              class="assistant"
              v-if="prologue && chatContentHasMore == false"
            >
              <div class="assistantTitle" @click="jumpToSettingPage">
                <img :src="agentInfo.icon" alt="" class="assistantHeadIcon" />
                <div class="assistantName" :class="{ white: changeColor }">
                  {{ assistant_name }}
                </div>
                <img
                  v-show="newChatInfo && ai_app_code != newChatInfo.ai_app_code"
                  class="right_arrow"
                  :src="
                    changeColor
                      ? 'https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_white.png'
                      : 'https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_black.png'
                  "
                  alt=""
                />
              </div>
              <div class="assistantAnswerContent">
                <div class="questionHintBox">
                  <div class="contentSummary">{{ prologue }}</div>
                  <div class="questionHintList">
                    <div
                      class="questionHintItem"
                      v-for="(value, key) in prologueList"
                      :key="key"
                      @click.stop="sendMessage(value)"
                    >
                      <div class="itemText">{{ value }}</div>
                      <img
                        class="right_arrow"
                        src="https://appflzt.oss-cn-shanghai.aliyuncs.com/static-h5/AI_H5/right_arrow_icon_gray.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 用户 机器人消息 -->
            <div
              v-for="(value, key) in chatContent"
              :key="value.id"
              class="userAndAssistant"
            >
              <!-- 用户提问 -->
              <!-- 添加临时push后的文件预览 -->
              <div
                class="assistantContainer"
                v-if="value.files && value.files.length > 0"
              >
                <div class="contentWrapper">
                  <filePreview
                    :dataHistoryConversation="value.files"
                    :aiAppCode="ai_app_code"
                  >
                  </filePreview>
                </div>
              </div>
              <!-- 历史会话拿到的文件预览 -->
              <div
                class="assistantContainer"
                v-if="value.message_files && value.message_files.length > 0"
              >
                <div class="contentWrapper">
                  <filePreview
                    :dataHistoryConversation="value.message_files"
                    :aiAppCode="ai_app_code"
                  >
                  </filePreview>
                </div>
              </div>
              <div class="user" v-if="value.query">
                <div class="userAnswerContent">
                  {{ value.query }}
                </div>
              </div>
              <!-- 助手回答 -->
              <div
                class="assistant"
                v-if="
                  !value.isBusiness &&
                  ((value.answer && value.answer != '') ||
                    (value.deepSeekAnswer && value.deepSeekAnswer != '') ||
                    (key == chatContent.length - 1 && isGenerating))
                "
              >
                <div class="assistantTitle" @click="jumpToSettingPage">
                  <img :src="agentInfo.icon" alt="" class="assistantHeadIcon" />
                  <div class="assistantName" :class="{ white: changeColor }">
                    {{ assistant_name }}
                  </div>
                  <img
                    v-show="
                      newChatInfo && ai_app_code != newChatInfo.ai_app_code
                    "
                    class="right_arrow"
                    :src="
                      changeColor
                        ? 'https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_white.png'
                        : 'https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_black.png'
                    "
                    alt=""
                  />
                </div>
                <div class="assistantAnswerContent">
                  <div class="answerContent" :id="'answerContent_' + value.id">
                    <div v-if="!value.isBusiness">
                      <!-- 思考中 -->
                      <div class="thinkingBox" v-if="value.isDeepSeek">
                        <!-- 思考顶部标签 -->
                        <div class="thinkingTitle">
                          <span class="span" v-if="!value.finishDeepSeek"
                            >思考中...</span
                          >
                          <span class="span" v-else>已深度思考</span>
                          <img
                            @click="foldThinkingContent(key)"
                            class="topArrow"
                            :class="{ topArrow_reverse: value.isFold }"
                            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/topArrowIcon_gray.png"
                            alt=""
                          />
                        </div>
                        <!-- 思考内容 -->
                        <div class="thinkingContentBox" v-show="!value.isFold">
                          <div class="leftLine"></div>
                          <div
                            class="thinkingContent"
                            v-html="markdownToHtml(value.deepSeekAnswer)"
                          ></div>
                        </div>
                      </div>
                      <!-- ceo 思考 -->
                      <div class="thinkingBox" v-if="value.isSpecialThink">
                        <!-- 思考顶部标签 -->
                        <div class="thinkingTitle">
                          <span class="span" v-if="!value.finishSpecialThink"
                            >思考中...</span
                          >
                          <span class="span" v-else>思考完成</span>
                          <img
                            @click="foldThinkingContent(key)"
                            class="topArrow"
                            :class="{ topArrow_reverse: value.isFold }"
                            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/topArrowIcon_gray.png"
                            alt=""
                          />
                        </div>
                        <!-- 思考内容 -->
                        <div
                          class="thinkingContentBox"
                          v-show="
                            !value.isFold && value.ceoAnimateArr.length > 0
                          "
                        >
                          <!-- ceo动画 -->
                          <div class="ceoAnimationBox">
                            <div
                              class="ceoAnimationItem"
                              v-for="(value2, key2) in value.ceoAnimateArr"
                              :key="key2"
                            >
                              <img
                                class="icon icon_rotate"
                                v-show="value2.status == 'loading'"
                                src="@/assets/ceoLoading.png"
                                alt=""
                              />
                              <img
                                class="icon"
                                v-show="value2.status == 'loadover'"
                                src="@/assets/ceoLoadSuccess.png"
                                alt=""
                              />
                              <div
                                class="text"
                                :class="{
                                  textAnimate: value2.status == 'loading',
                                }"
                              >
                                <span>{{ value2.text }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- 正文回复 -->
                      <div
                        @click="clickMarkdown($event)"
                        :ref="'answerText' + key"
                        class="answerText"
                        v-html="markdownToHtml(value.answer)"
                      ></div>
                      <div
                        class="AI_generating_box"
                        v-if="key == chatContent.length - 1 && isGenerating"
                      >
                        <div class="AI_generating" id="AI_generating"></div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="answerOptions"
                    v-show="
                      (key != chatContent.length - 1 || !isGenerating) &&
                      !value.isBusiness &&
                      value.answer != '' &&
                      !value.isImage
                    "
                  >
                    <!-- 复制按钮 -->
                    <img
                      @click="clickCopyBtn(key)"
                      class="optionsIcon"
                      src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/copyIcon_gray.png"
                      alt=""
                    />
                    <!-- 播放 取消播放  文字转语音 -->
                    <div class="playVoiceBox" v-if="!hideTTSBtn">
                      <!-- 播放按钮 -->
                      <img
                        class="optionsIcon"
                        src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/playVoiceIcon.png"
                        alt=""
                        @click="clickPlayBtn(key)"
                        v-show="playingContentIndex != key"
                      />
                      <!-- 播放中 点击取消播放 -->
                      <img
                        class="optionsIcon"
                        src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/playingVoiceIcon.png"
                        alt=""
                        @click="clickStopPlayBtn(key)"
                        v-show="playingContentIndex == key"
                      />
                    </div>
                  </div>
                  <div class="answerOptions" v-show="value.isImage">
                    <!-- 下载按钮 -->
                    <img
                      @click="downloadImage(value.answer)"
                      class="optionsIcon"
                      src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/saveImageBtn_small.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <!-- 助手回答-业务 -->
              <div
                class="businessBox"
                v-if="value.isBusiness && value.modal_card"
              >
                <div class="assistantTitle" @click="jumpToSettingPage">
                  <img :src="agentInfo.icon" alt="" class="assistantHeadIcon" />
                  <div class="assistantName" :class="{ white: changeColor }">
                    {{ assistant_name }}
                  </div>
                  <img
                    v-show="
                      newChatInfo && ai_app_code != newChatInfo.ai_app_code
                    "
                    class="right_arrow"
                    :src="
                      changeColor
                        ? 'https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_white.png'
                        : 'https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_black.png'
                    "
                    alt=""
                  />
                </div>
                <!-- 二维码业务 -->
                <qrCodeBox
                  v-if="value.modal_card.type == 'qrCode'"
                  :businessContent="value.modal_card"
                ></qrCodeBox>
                <!-- 实时公交业务 -->
                <realTimeBusBox
                  v-if="
                    value.modal_card.type == 'nearbyStation' ||
                    value.modal_card.type == 'stationDetail' ||
                    value.modal_card.type == 'lineDetail' ||
                    value.modal_card.type == 'lineSchedule'
                  "
                  :businessContent="value.modal_card"
                ></realTimeBusBox>
                <!-- MaaS业务 -->
                <MaaSBox
                  v-if="value.modal_card.type == 'maasPlan'"
                  :businessContent="value.modal_card"
                ></MaaSBox>
                <!-- 打车业务 -->
                <takeTaxiBox
                  v-if="value.modal_card.type == 'taxi'"
                  :businessContent="value.modal_card"
                >
                </takeTaxiBox>
                <!-- 汽车票业务 -->
                <coachBox
                  v-if="value.modal_card.type == 'coach'"
                  :businessContent="value.modal_card"
                ></coachBox>
                <!-- 火车业务 -->
                <trainBox
                  v-if="value.modal_card.type == 'train'"
                  :businessContent="value.modal_card"
                ></trainBox>
                <!-- 机票业务 -->
                <airplaneBox
                  v-if="value.modal_card.type == 'flight'"
                  :businessContent="value.modal_card"
                ></airplaneBox>
                <!-- 停车业务 -->
                <parkCarBox
                  v-if="value.modal_card.type == 'parking'"
                  :businessContent="value.modal_card"
                ></parkCarBox>
                <!-- 地铁业务 -->
                <metroBox
                  v-if="
                    value.modal_card.type == 'metroLine' ||
                    value.modal_card.type == 'metroLocation' ||
                    value.modal_card.type == 'metroFare' ||
                    value.modal_card.type == 'metroSchedule'
                  "
                  :businessContent="value.modal_card"
                ></metroBox>
                <!-- 会员业务 -->
                <vipBox
                  v-if="value.modal_card.type == 'member'"
                  :businessContent="value.modal_card"
                ></vipBox>
                <!-- 积分商城 -->
                <pointMallBox
                  v-if="value.modal_card.type == 'points'"
                  :businessContent="value.modal_card"
                ></pointMallBox>
                <!-- 权益中心 -->
                <equityCenterBox
                  v-if="value.modal_card.type == 'rights'"
                  :businessContent="value.modal_card"
                >
                </equityCenterBox>
              </div>
            </div>
            <!-- 提示语 -->
            <div
              class="suggestedBox"
              v-if="suggestedData.length > 0 && !isGenerating"
            >
              <div
                class="suggestedItem"
                :class="{ suggestedItemChangeColor: changeColor }"
                v-for="(value, key) in suggestedData"
                :key="key"
                @click.stop="clickSuggested(value)"
              >
                {{ value }}
              </div>
            </div>
          </div>
        </van-pull-refresh>

        <div class="showNewChat" v-show="showNewChat">
          <div class="newChatBox">
            <img class="img" :src="agentInfo.icon" alt="" />
            <div class="text">聊聊新话题</div>
          </div>
        </div>
      </div>

      <!-- 底部对话框 -->
      <div class="bottomInputBox">
        <!-- 停止响应box -->
        <div class="stopGeneratingBox" v-show="1 == 2" @click="stopGenerating">
          <div class="stopGeneratingButton">
            <img
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/stop_btn_gray.png"
              alt=""
              class="stop_btn_gray"
            />
            <div class="stopGeneratingText">停止响应</div>
          </div>
        </div>
        <!-- 滚动至底部box -->
        <transition name="fade">
          <div
            class="scrollToBottomBtn"
            v-if="ShowScrollToBottomBtn"
            @click="scrollToBottom(true)"
          >
            <img
              class="down_arrow_icon_black"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/down_arrow_icon_black.png"
              alt=""
            />
          </div>
        </transition>
        <div class="bottomInputContainer">
          <div class="bottomInputFileAndInput">
            <filePreview
              :receivedFileData="dataFromUpload"
              :aiAppCode="ai_app_code"
              @sendFilesWaitUpload="sendFilesWaitUpload"
            >
            </filePreview>
            <div
              class="bottomInputContent"
              :class="{
                bottomInputContent_active:
                  textAreaFocus ||
                  inputContent != '' ||
                  isTranslating ||
                  isRecording,
              }"
            >
              <div
                class="textareaBox_outer"
                v-show="!isRecording && !isTranslating"
              >
                <!-- 输入框 -->
                <div class="textareaBox">
                  <textarea
                    v-model="inputContent"
                    class="textarea"
                    placeholder="有什么问题尽管问我"
                    maxlength="999"
                    ref="textarea"
                    @focus="textAreaOnFocus"
                    @blur="textAreaOnBlur"
                  ></textarea>
                  <div class="textareaDiv">
                    {{ inputContent ? inputContent : "有什么问题尽管问我" }}
                  </div>
                </div>
              </div>
              <!-- 录音框 -->
              <div class="recordTextBox" v-show="isRecording || isTranslating">
                <div class="recordText" v-show="!isTranslating">现在讲...</div>
                <div class="recordText" v-show="isTranslating">
                  正在转换为文本...
                </div>
              </div>
              <!-- 停止生成按钮 -->
              <img
                @click="stopGenerating"
                v-show="isGenerating"
                class="stopGenerating_big"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/stopGenerating_big.png"
                alt=""
              />
              <!-- 发送按钮 -->
              <img
                @click="sendMessage(inputContent)"
                v-show="
                  inputContent.length > 0 &&
                  !isRecording &&
                  !isTranslating &&
                  !isGenerating
                "
                class="submitBtn_icon"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/submitBtnIcon.png"
                alt=""
              />
              <!-- 文件上传按钮 -->
              <!-- 根据后端返回的最大上传数，限定文件数量，超出时不再允许选择 -->
              <uploadFile
                v-show="
                  inputContent.length == 0 &&
                  !isRecording &&
                  !isTranslating &&
                  showFileUpload &&
                  !isGenerating &&
                  maxUploadCnt > completeFiles.length
                "
                @sendFilesData="sendFilesData"
              >
              </uploadFile>
              <!-- 开始录音按钮 -->
              <img
                @click="startRecord"
                v-show="
                  inputContent.length == 0 &&
                  !isRecording &&
                  !isTranslating &&
                  !isGenerating
                "
                class="record_submitBtn_icon"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/startRecordBtn.png"
                alt=""
              />
              <!-- 停止录音按钮 -->
              <img
                @click="stopRecord"
                v-show="isRecording && !isGenerating"
                class="submitBtn_icon"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/stopRecordBtn_big2.png"
                alt=""
              />
              <!-- 停止语音转文字 -->
              <img
                @click="stopAudioToText"
                v-show="isTranslating && !isGenerating"
                class="stopTranslateBtn"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/stopTranslateBtn_big.png"
                alt=""
              />
              <!-- 计时 -->
              <div class="timerBox" v-show="isRecording || isTranslating">
                {{ dateTimeFormat }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 生成异常dialog -->
    <commonDialog
      @clickSubmit="showGeneratingErrorDialog = false"
      v-model="showGeneratingErrorDialog"
      :textContent="generatingErrorMsg"
      submitBtnText="我知道了"
    ></commonDialog>

    <van-popup v-model="showQrCodePopup" position="bottom">
      <div class="qrCodePopupContent">
        <div class="qrCodePopupTitleBox">
          <div class="qrCodePopupTitle">公交乘车码</div>
          <img
            @click="showQrCodePopup = false"
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/close_btn_black.png"
            alt=""
            class="close_btn_black"
          />
        </div>
        <div class="qrCodeContent">
          <div class="qrCodeNo" v-if="qrCodeNo">NO.{{ qrCodeNo }}</div>
          <img
            @click="showQrCode"
            class="qrCodeImage"
            :src="qrCodeData"
            alt=""
          />
          <div class="qrCodeHint">点击二维码刷新</div>
        </div>
      </div>
    </van-popup>

    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>

    <!-- 自动播放 -->
    <div class="fixedOptions">
      <div
        v-if="!hideTTSBtn"
        class="autoPlayVoiceIconBox"
        @click="clickSwitchAutoTTS"
      >
        <img
          v-if="isAutoPlayVoice"
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/autoPlayVoiceIcon_enable.png"
          alt=""
        />
        <img
          v-else
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/autoPlayVoiceIcon_disabled.png"
          alt=""
        />
      </div>
      <div
        class="centerLineBox"
        v-if="chatDetail && chatDetail.inputParam && !hideTTSBtn"
      >
        <div class="centerLine"></div>
      </div>
      <div
        v-if="chatDetail && chatDetail.inputParam"
        class="user_input_formBox"
        @click="clickOpenUserInputForm"
      >
        <img
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/user_inputs_icon.png"
          alt=""
          class="icon"
        />
      </div>
    </div>

    <!-- 顶部的选项框 这个选项框 宽高100% -->
    <div class="chatOptionsDialog" v-if="show_user_input_form">
      <div class="shadeBox" @click="clickFormShadeBox"></div>
      <div class="chatOptionsDialogContent">
        <div class="p1">会话参数设置</div>
        <div
          class="optionItem"
          v-for="(value, key) in user_input_form"
          :key="key"
        >
          <div class="optionTitleBox">
            <span class="optionTitle">{{ value.label }}</span>
            <span class="optionHint" v-if="value.required == false">可选</span>
          </div>
          <!-- 普通输入框 -->
          <div class="optionContent" v-if="value.type == 'text-input'">
            <input
              v-model="value.value"
              :maxlength="value.max_length"
              :placeholder="value.label"
              class="optionInput"
              type="text"
            />
          </div>
          <!-- 选择器 -->
          <div
            class="optionContent"
            v-if="value.type == 'select'"
            @click="onUserInputClickPicker(key)"
          >
            <div class="optionValue">{{ value.value }}</div>
            <img
              class="down_arrow_icon_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/down_arrow_icon_gray.png"
              alt=""
            />
            <van-popup
              :get-container="getContainer"
              :close-on-click-overlay="false"
              v-model="value.showPicker"
              round
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="value.options"
                @cancel="onUserInputPickerCancel(key)"
                @confirm="onUserInputPickerConfirm($event, key)"
              />
            </van-popup>
          </div>
        </div>
        <div class="startChatBtn" @click="clickFormShadeBox">开始对话</div>
      </div>
    </div>

    <!-- 会员专属提示 dialog -->
    <commonDialog2
      :show="showVipOnlyDialog"
      titleContent="该智能体为会员专属智能体"
      textContent="开通会员后，可与专属智能体对话。"
      leftBtnText="取消"
      leftBtnColor="#007AFF"
      leftBtnBold
      rightBtnText="去开通"
      rightBtnColor="#007AFF"
      @clickLeft="showVipOnlyDialog = false"
      @clickRight="clickOpenVipBtn"
    ></commonDialog2>
  </div>
</template>

<script>
import realTimeBusBox from "@/components/realTimeBusBox/realTimeBusBox";
import pointMallBox from "@/components/pointMallBox/pointMallBox";
import equityCenterBox from "@/components/equityCenterBox/equityCenterBox";
import vipBox from "@/components/vipBox/vipBox";
import metroBox from "@/components/metroBox/metroBox";
import MaaSBox from "@/components/MaaSBox/MaaSBox";
import parkCarBox from "@/components/parkCarBox/parkCarBox";
import trainBox from "@/components/trainBox/trainBox";
import coachBox from "@/components/coachBox/coachBox";
import qrCodeBox from "@/components/qrCodeBox/qrCodeBox";
import takeTaxiBox from "@/components/takeTaxiBox/takeTaxiBox";
import AirplaneBox from "@/components/airplaneBox/airplaneBox";
import { previewImage } from "@/utils/previewImage";
import { Toast } from "vant";
import * as Http from "@/api/HttpService.js";
import { API } from "@/api/HttpConfig.js";
import { marked } from "marked";
import record from "@/utils/record.js";
import copy from "clipboard-copy";
import lottie from "lottie-web";
import loadingJSON from "@/assets/loading.json";
import voicePlayingJSON from "@/assets/voicePlaying.json";
import * as Gateway from "@/api/GatewayConfig";
import AudioPlayer from "@/common/js/AudioPlayer";
import { getLocation, getLocationFromWechatApp } from "@/utils/locationUtils";
import {
  specialCodeHead,
  deepSeekHead,
  deepSeekFooter,
  imgContentHead,
} from "@/config/config";
import { businessCodeMatch } from "@/utils/businessCodeMatch";
import UploadFile from "@/components/uploadFile/uploadFile.vue";
import filePreview from "@/components/filePreview/filePreview.vue";
import cloneDeep from "clone-deep";
marked.setOptions({
  mangle: false, // 防止转义电子邮件地址（可选）
  headerIds: false, // 如果你也不想生成header id（可选）
  // 关键设置 ↓↓↓
  gfm: false, // 关闭 GitHub Flavored Markdown，从而禁用自动链接
});
const renderer = new marked.Renderer();
renderer.image = function (href, title, text) {
  return `<img src="${href.href}" alt="${text}" class="width100">`;
};

export default {
  components: {
    UploadFile,
    filePreview,
    vipBox,
    metroBox,
    MaaSBox,
    parkCarBox,
    qrCodeBox,
    takeTaxiBox,
    coachBox,
    trainBox,
    AirplaneBox,
    equityCenterBox,
    pointMallBox,
    realTimeBusBox,
  },
  mounted: async function () {
    this.getLocation();
    console.log("mounted————————————————————————————————————————");
    const MediaSource = window.ManagedMediaSource || window.MediaSource;
    if (!MediaSource) {
      this.hideTTSBtn = true;
    }
    document.addEventListener("visibilitychange", this.visibilitychange);
    // 拦截a标签
    if (!window.aTagIntercept) {
      let isWechatProgram = window.__wxjs_environment ? true : false;
      if (isWechatProgram) {
        document.body.addEventListener("click", () => {
          // 兼容处理
          var target = event.target || event.srcElement;
          // console.log(target);
          // console.log(target.getAttribute("canJump"));
          // 判断是否匹配目标元素
          if (!target.getAttribute("canJump")) {
            if (target.nodeName.toLocaleLowerCase() === "a") {
              console.log("当前点击的 a 标签: ", target);
              // 对捕获到的 a 标签进行处理，需要先禁止它的跳转行为
              if (event.preventDefault) {
                event.preventDefault();
              } else {
                window.event.returnValue = true;
              }
              // 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
              let url = target.getAttribute("href");
              this.$router.push({
                name: "ATagHintPage",
                query: {
                  url: encodeURIComponent(url),
                },
              });
            }
          } else {
            console.log("该a标签可以自由跳转");
          }
        });
      }
      window.aTagIntercept = true;
    }
    document.addEventListener("wheel", this.stopAutoScroll);
    this.userId = window.localStorage.getItem("userId_AI");
    let params = this.$route.query;
    this.ai_app_code = params.ai_app_code;
    await this.getAgentInfo();
    this.conversation_id = params.conversation_id;
    await this.getAutoTTSInfo();

    // 如果当前打开了自动播放
    if (this.isAutoPlayVoice) {
      // 查一下需不需要关闭
      let resultTTS = await this.getTTSLimit();
      if (resultTTS.code == "TTS_LIMIT") {
        // 关闭
        this.switchAutoTTS(0);
      }
    }
    // 获取开场白
    await this.getPrologue();
    await this.getUserVipInfo();
    await this.getChatDetail();
    if (this.$store.getters.totalCount <= 0) {
      await this.getConversationCount();
    }

    // 如果当前智能体需要用户输入参数，则展示表单
    if (this.chatDetail.inputParam == 1) {
      this.show_user_input_form = true;
    }
    // 修改标题
    if (params.name) {
      document.title = params.name;
      this.assistant_name = params.name;
    } else {
      document.title = this.agentInfo.name;
      this.assistant_name = this.agentInfo.name;
    }
    if (params.userInputs) {
      let obj = JSON.parse(params.userInputs);
      for (let i of this.user_input_form) {
        if (obj[i.variable]) {
          i.value = obj[i.variable];
        }
      }
    }
    // 如果进来的时候  发现了autoJumpToAgent字段
    if (this.$route.query.autoJumpToAgent) {
      console.log("发现了autoJumpToAgent字段");
      // 先查一下有没有conversation_id
      let result = await this.findConversation();
      console.log(result);
      // 如果存在conversation_id
      if (result && result.conversation_id) {
        this.conversation_id = result.conversation_id;
      }
      // 不存在conversation_id
      else {
        // 创建会话
        let result = await this.addFindAgent();
        if (result) {
          console.log("会话创建成功");
        } else {
          this.$toast("会话创建失败，请刷新页面并重试");
          return;
        }
      }
    }
    // 如果是点击了新对话
    if (
      this.newChatInfo &&
      params.ai_app_code == this.newChatInfo.ai_app_code &&
      !params.conversation_id
    ) {
      this.showNewChat = true;
    } else {
      // 加载历史记录
      if (this.conversation_id) {
        // 如果发现了刚刚删除了上下文  那么就不加载历史记录
        if (this.$store.getters.hasClear) {
          this.$store.commit("hasClear", false);
          this.conversation_id = null;
          // 删除地址栏中的conversation_id
          const newQuery = { ...this.$route.query };
          // 删除conversation_id参数
          delete newQuery.conversation_id;
          // 替换路由，保留其他参数
          this.$router.replace({
            name: "ChatDetailPage",
            query: newQuery,
          });
        } else {
          await this.getHistoryMessageDetail();
          // 顺便加载提示语
          setTimeout(async () => {
            if (
              this.chatContent.length > 0 &&
              this.chatContent[this.chatContent.length - 1].isBusiness == false
            ) {
              await this.getSuggested();
            }
          }, 500);
        }
      } else {
        this.$store.commit("hasClear", false);
      }
    }
  },
  beforeDestroy: function () {
    if (this.audioPlayer) {
      this.clickStopPlayBtn();
    }
    if (this.isGenerating) {
      this.stopGenerating();
    }
    document.removeEventListener("visibilitychange", this.visibilitychange);
  },
  destroyed: function () {
    document.removeEventListener("wheel", this.stopAutoScroll);
    this.stopTimer();
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  },
  computed: {
    calculateChatLimit: function () {
      // 渠道额度正常
      if (this.chatDetail && this.isHasChatLimit) {
        // 用户是会员    并且智能体的会员额度 没有额度限制
        if (this.isVip && this.chatDetail.vipChatLimit === null) {
          return {
            show: false,
          };
        }
        // 用户不是会员   并且智能体的普通额度 没有额度限制
        if (!this.isVip && this.chatDetail.chatLimit === null) {
          return {
            show: false,
          };
        }
        // 用户是会员 智能体是会员
        if (this.isVip && this.agentInfo.vipOnly == 1) {
          return {
            show: true,
            text: `会员额度 ${
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? this.chatDetail.vipChatLimit - this.chatDetail.usedCount
                : 0
            }/${this.chatDetail.vipChatLimit}`,
            color:
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? "normal"
                : "red",
          };
        }
        // 用户是会员 智能体不是会员
        if (this.isVip && this.agentInfo.vipOnly == 0) {
          return {
            show: true,
            text: `会员额度 ${
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? this.chatDetail.vipChatLimit - this.chatDetail.usedCount
                : 0
            }/${this.chatDetail.vipChatLimit}`,
            color:
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? "normal"
                : "red",
          };
        }
        // 用户不是会员 智能体是会员
        if (!this.isVip && this.agentInfo.vipOnly == 1) {
          return {
            show: true,
            text: "会员已过期",
            color: "normal",
          };
        }
        // 用户不是会员 智能体不是会员
        if (!this.isVip && this.agentInfo.vipOnly == 0) {
          return {
            show: true,
            text: `今日剩余 ${
              this.chatDetail.chatLimit - this.chatDetail.usedCount > 0
                ? this.chatDetail.chatLimit - this.chatDetail.usedCount
                : 0
            }/${this.chatDetail.chatLimit}`,
            color:
              this.chatDetail.chatLimit - this.chatDetail.usedCount > 0
                ? "normal"
                : "red",
          };
        }
      }
      // 渠道额度用完
      if (this.chatDetail && !this.isHasChatLimit) {
        return {
          show: true,
          text: "总额度已用完",
          color: "normal",
        };
      }
      // 未获取到渠道额度 或者未获取到智能体信息
      return {
        show: false,
      };
    },
    // 助手背景图
    agent_bg: function () {
      if (this.agentInfo && this.agentInfo.backImgUrl) {
        return `background-image:url(${this.agentInfo.backImgUrl});`;
      } else {
        return "background-color:white;";
      }
    },
    // 颜色是否变色
    changeColor: function () {
      if (this.agentInfo && this.agentInfo.backImgUrl) {
        return true;
      } else {
        return false;
      }
    },
    newChatInfo: function () {
      return this.$store.getters.newChatInfo;
    },
    // 判断今日是否还有额度
    isHasChatLimit: function () {
      if (this.isVip) {
        return (
          this.$store.getters.vipTotalCount - this.$store.getters.currentCount >
            0 &&
          this.$store.getters.totalTokenCount -
            this.$store.getters.currentTokenCount >
            0
        );
      } else {
        return (
          this.$store.getters.totalCount - this.$store.getters.currentCount >
            0 &&
          this.$store.getters.totalTokenCount -
            this.$store.getters.currentTokenCount >
            0
        );
      }
    },
  },
  data: function () {
    return {
      // 当前用户是否是vip
      isVip: false,
      // 会员专属dialog提示
      showVipOnlyDialog: false,
      // 当前额度 配置
      chatDetail: null,
      // nowLocation: "109.415997,24.320713",
      nowLocation: "",
      conversationContent: null,
      loading: false,
      // websocket实例
      ws: null,
      // AI状态 是否是生成中
      isGenerating: false,
      // 用户输入内容
      inputContent: "",
      // 当前的conversation_id
      conversation_id: null,
      // 当前对话内容  type 1=>正常文本内容  2=>问题建议
      chatContent: [],
      chatContentHasMore: false,
      chatContentLoading: false,
      // 介绍
      prologue: "",
      // 开场白列表
      prologueList: [],
      // 是否执行自动滚动
      isAutoScroll: false,
      // 是否等待滚动
      waitScroll: false,
      // 任务id 供停止响应接口使用
      task_id: null,
      // 请求Id  前端生成
      requestId: null,
      // 文本生成异常 dialog
      showGeneratingErrorDialog: false,
      generatingErrorMsg: "",
      // 是否处于录音状态
      isRecording: false,
      // 是否处于转换中状态
      isTranslating: false,
      // 是否强制停止转换
      isStopAudioToText: true,
      // 计时器
      timer: null,
      // 分钟
      dateTimeFormat: "00:00",
      // 一共多少秒钟
      second: 0,
      hasInsertNewChat: false,
      // 录音防抖锁
      recordDebounceLock: false,
      // 输入框是否聚焦
      textAreaFocus: false,
      //   助手名称
      assistant_name: "",
      // 展示新对话
      showNewChat: false,
      ai_app_code: null,
      suggestedData: [],
      ShowScrollToBottomBtn: false,
      // message_end error 异常情况：提问后，如果没返回message 直接返回了message_end 这里加一个开关区分一下
      message_end_error: false,
      // 当前播放的index下标
      playingContentIndex: -1,
      currentPlayingContentIndex: -1,
      // 本轮对话是否已经播放过（即便是播放失败）
      currentHasAutoPlaying: false,
      // 播放器dom实例
      audioPlayer: null,
      mediaSource: null,
      controller: null,
      signal: null,
      sourceBuffer: null,
      // 是否隐藏文字转语音按钮
      hideTTSBtn: false,
      // 临时存储回答返回的字符串  用来跟业务编码的特殊抬头做匹配
      // 只找前几位，如果前几位不符合，直接放弃查找
      responseTempStr: "",
      // 本次查询是否匹配到了特殊抬头 0=>尚未匹配  1=>匹配成功（业务编码）  2=>匹配成功(深度思考)   99=>匹配失败
      isMatchSpecialHead: 0,
      // 深度思考是否思考完毕
      finishDeepSeek: false,
      // 文件上传获得的数据
      dataFromUpload: [],
      // 已上传成功，待与会话一起发送的文件 取值后端返回文件id，待ws传回
      filesWaitUpload: [],
      // 已上传成功，待push到会话列表预览
      completeFiles: [],
      //最大可上传文件数
      maxUploadCnt: 0,
      //是否显示文件上传按钮
      showFileUpload: false,
      // 是否展示二维码弹窗
      showQrCodePopup: false,
      // 二维码数据
      qrCodeData: null,
      // 二维码编码
      qrCodeNo: null,
      // 智能体配置信息
      agentInfo: null,
      // 是否是自动播放状态
      isAutoPlayVoice: false,
      // 记录在提问时的 自动播放状态 （当提问时自动播放处于关闭状态  提问后立刻打开自动播放按钮  本轮回答  不会自动播放）
      isAutoPlayVoice_current: false,

      // ceo 效果列表
      ceoTextArr: [
        "识别意图中",
        "调取资料中",
        "智能匹配中",
        "检索片段中",
        "大模型生成中",
        "业务分析中",
        "结构化结果中",
        "完成",
      ],
      // ceo 动画是否播放完毕
      ceoAnimationPlayOver: false,
      // 本轮对话是否需要展示ceo 动画
      needPlayCeoAnimation: false,
      // ceo 文本是否生成完毕
      ceoAnimationMessageEnd: false,

      // modal_card data
      modal_card: null,
      // 是否展示提交表单
      show_user_input_form: false,
      // 表单选项
      user_input_form: [],
    };
  },
  methods: {
    getContainer() {
      return document.querySelector("#ChatDetailPage");
    },
    // 获取今日会话次数
    getConversationCount: async function () {
      let params = {};
      await Http.getConversationCount(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.$store.commit(
              "currentCount",
              res.originalData.data.currentCount
            );
            this.$store.commit("totalCount", res.originalData.data.totalCount);
            this.$store.commit(
              "currentTokenCount",
              res.originalData.data.currentTokenCount
            );
            this.$store.commit(
              "totalTokenCount",
              res.originalData.data.totalTokenCount
            );
            this.$store.commit(
              "vipTotalCount",
              res.originalData.data.vipTotalCount
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
    },
    // 获取位置信息
    getLocation: async function () {
      // 判断当前env是否是小程序环境
      if (window.__wxjs_environment) {
        let result = await getLocationFromWechatApp();
        if (result) {
          this.nowLocation = `${result.lng},${result.lat}`;
        }
      } else {
        let result = await getLocation();
        console.log("这是获取到的位置信息", result);
        if (
          result &&
          result.responseData &&
          result.responseData.latitude &&
          result.responseData.longitude
        ) {
          this.nowLocation = `${result.responseData.longitude},${result.responseData.latitude}`;
        }
      }
    },
    // 点击表单其他区域
    clickFormShadeBox: function () {
      let result = this.checkForm();
      if (result !== true) {
        this.$toast(`请填写${result}`);
      } else {
        this.show_user_input_form = false;
      }
    },
    // 校验用户inputs表单
    checkForm: function () {
      if (this.chatDetail.inputParam == 1) {
        for (let i of this.user_input_form) {
          if (i.required && !i.value) {
            return i.label;
          }
        }
      }
      return true;
    },
    onUserInputClickPicker: function (key) {
      this.user_input_form[key].showPicker = true;
    },
    onUserInputPickerConfirm: function ($event, key) {
      console.log($event, key);
      this.user_input_form[key].value = $event;
      setTimeout(() => {
        this.user_input_form[key].showPicker = false;
      }, 100);
    },
    onUserInputPickerCancel: function (key) {
      console.log(key);
      setTimeout(() => {
        this.user_input_form[key].showPicker = false;
      }, 100);
    },
    clickOpenUserInputForm: function () {
      this.show_user_input_form = true;
    },
    // 获取会员信息
    getUserVipInfo: async function () {
      let params = {
        bizSession: localStorage.getItem("sessionId"),
      };
      await Http.getUserVipInfo(params).then(({ res }) => {
        if (res.code == "SUCCESS") {
          this.isVip = res.originalData.data.status == "1" ? true : false;
        }
      });
    },
    // 点击去开通会员按钮
    clickOpenVipBtn: function () {
      let url = process.env.VUE_APP_VIP_LIUZHOU_H5;
      url =
        url +
        `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
          "sessionId"
        )}&target=VipDetailPage`;
      window.location.href = url;
    },
    // 点击markdown内容
    clickMarkdown: function (event) {
      // 获取被点击的元素
      const clickedElement = event.target;

      // 检查被点击的元素是否是图片
      if (clickedElement.tagName === "IMG") {
        // 如果点击的是图片，获取图片的src并预览
        const imageSrc = clickedElement.src;
        if (imageSrc) {
          previewImage(imageSrc);
        } else {
          console.log("图片 src 为空");
        }
      }
      // 如果点击的不是图片，不做任何操作
    },
    // 下载图片
    downloadImage: function (answer) {
      const match = answer.match(/!\[[^\]]*\]\((.*?)\)/);
      if (match) {
        if (window.__wxjs_environment) {
          this.$toast("请长按图片保存");
        } else {
          var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
          var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          if (isAndroid || isIos) {
            DXLC_JSSDK(
              "saveFile",
              {
                type: "image",
                dataType: "url",
                dataSource: match[1],
              },
              (result) => {
                console.log(result);
                let res = null;
                if (isAndroid) {
                  res = JSON.parse(result);
                } else if (isIos) {
                  res = result;
                }
                if (res.code == "0") {
                  this.$toast("图片已保存");
                } else {
                  this.$toast(res.msg);
                }
              }
            );
          }
        }
      } else {
        console.log("未匹配到图片 URL");
      }
    },
    // 绘制亮啦ceo动画
    playCeoAnimation: async function (result) {
      // 直接插到最后一个
      let index = this.chatContent.length - 1;
      for (let i of this.ceoTextArr) {
        if (this.isGenerating == false) {
          return;
        }
        await new Promise((resolve, reject) => {
          setTimeout(() => {
            let obj = {
              text: i,
              status: "loading",
            };
            this.chatContent[index].ceoAnimateArr.push(obj);
            setTimeout(() => {
              let index2 = this.chatContent[index].ceoAnimateArr.length - 1;
              this.chatContent[index].ceoAnimateArr[index2].status = "loadover";
              this.scrollToBottom(false);
              resolve();
            }, 1000);
          }, 500);
        });
      }
      this.chatContent[index].finishSpecialThink = true;
      this.ceoAnimationPlayOver = true;
      this.onMessage(result);
      if (this.ceoAnimationMessageEnd) {
        this.messageEnd(result);
      }
    },
    // 查询tts token数量
    getTTSLimit: async function () {
      let params = {};
      let result = await Http.getTTSLimit(params)
        .then(({ res }) => {
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            return {
              code: "SUCCESS",
              remainToken: res.originalData.data.remainToken,
            };
          } else if (res.originalData.code == "TTS_LIMIT") {
            return {
              code: "TTS_LIMIT",
            };
          } else {
            this.$toast(res.originalData.msg);
            return false;
          }
        })
        .catch((err) => {
          this.$toast("网络异常");
          return false;
        });
      return result;
    },
    // 查询是否自动播放
    getAutoTTSInfo: async function () {
      let params = {
        conversationId: this.conversation_id,
        ai_app_code: this.ai_app_code,
      };
      await Http.getAutoTTSInfo(params)
        .then(({ res }) => {
          console.log(res);
          console.log(res.originalData.data);
          console.log(this.hideTTSBtn);
          if (res.originalData.code == "SUCCESS") {
            this.isAutoPlayVoice = res.originalData.data && !this.hideTTSBtn;
            console.log(this.isAutoPlayVoice);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clickSwitchAutoTTS: async function () {
      // 只有在将要打开自动播放的时候  才进行判断
      if (this.isAutoPlayVoice == false) {
        let result = await this.getTTSLimit();
        if (result.code == "SUCCESS") {
          this.switchAutoTTS();
        }
        // 达到播放上限  关闭自动播放
        else if (result.code == "TTS_LIMIT") {
          this.$toast("今日语音播放额度已用完，请明日再试");
        }
      } else {
        this.switchAutoTTS();
      }
    },

    // 打开/关闭 自动播放
    switchAutoTTS: async function (state) {
      let params = {
        conversationId: this.conversation_id,
        ai_app_code: this.ai_app_code,
      };
      if (state !== undefined) {
        params.state = state;
      } else if (this.isAutoPlayVoice) {
        params.state = 0;
      } else {
        params.state = 1;
      }
      console.log(params);
      this.loading = true;
      await Http.switchAutoTTS(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS" && res.originalData.code == "SUCCESS") {
            if (params.state === 0) {
              this.isAutoPlayVoice = false;
              if (state === undefined) {
                this.$toast("已关闭语音自动播放功能");
              }
              if (this.audioPlayer) {
                this.clickStopPlayBtn();
              }
            } else {
              this.isAutoPlayVoice = true;
              if (state === undefined) {
                this.$toast("已开启语音自动播放功能");
              }
            }
          } else {
            this.$toast(res.originalData.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    },
    // 查询智能体信息
    getAgentInfo: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
        system: localStorage.getItem("channelCode_AI"),
      };
      await Http.getAgentInfo(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            // 应用被下架
            if (!res.originalData.data) {
              this.$toast("应用已下架");
              setTimeout(() => {
                this.$router.back();
                return;
              }, 1000);
            } else {
              this.agentInfo = res.originalData.data;
              let newChatInfo = this.$store.getters.newChatInfo;
              let defaultChatInfo = this.$store.getters.defaultChatInfo;
              let url = window.location.href;
              // 如果地址栏中已经包含了share_ai_app_code   那么直接返回就行
              if (url.indexOf("share_ai_app_code") != -1) {
                return;
              }
              if (url.indexOf("?") != -1) {
                url = url + "&";
              } else {
                url = url + "?";
              }
              // 如果既有新对话，又有默认对话
              if (newChatInfo && defaultChatInfo) {
                // 如果当前的code是新对话   那么分享默认对话
                if (this.ai_app_code == newChatInfo.ai_app_code) {
                  url =
                    url +
                    `share_ai_app_code=${
                      defaultChatInfo.ai_app_code
                    }&desction=${
                      defaultChatInfo.desction
                    }&shareImgUrl=${encodeURIComponent(
                      defaultChatInfo.shareImgUrl
                    )}`;
                  window.history.replaceState(null, document.title, url);
                }
                // 否则  分享的是当前code的对话
                else {
                  url =
                    url +
                    `share_ai_app_code=${this.agentInfo.ai_app_code}&desction=${
                      this.agentInfo.desction
                    }&shareImgUrl=${encodeURIComponent(
                      this.agentInfo.shareImgUrl
                    )}`;
                  window.history.replaceState(null, document.title, url);
                }
              }
              // 只有新对话
              else if (newChatInfo) {
                // 什么都不用做
              }
              // 只有默认对话
              else if (defaultChatInfo) {
                // 分享当前code的对话
                url =
                  url +
                  `share_ai_app_code=${this.agentInfo.ai_app_code}&desction=${
                    this.agentInfo.desction
                  }&shareImgUrl=${encodeURIComponent(
                    this.agentInfo.shareImgUrl
                  )}`;
                window.history.replaceState(null, document.title, url);
              }
              // 既没有新对话 有没有默认对话
              else {
                // 什么都不用做
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询会话详情 获取当前会话额度&inputs参数
    getChatDetail: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
      };
      await Http.getChatDetail(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.chatDetail = res.originalData.data;
            if (this.chatDetail.inputs) {
              let obj = JSON.parse(this.chatDetail.inputs);
              for (let i of this.user_input_form) {
                if (obj[i.variable]) {
                  i.value = obj[i.variable];
                }
              }
            }
          }
        })
        .catch((err) => {});
    },
    // channel 4种情况  dxlc_lz_app dxlc_lz_wx cxnt_xh_app cxnt_xh_wx  dxlc_test（测试用）
    showQrCode: async function () {
      let params = {
        size: 250,
      };
      let apiPath = "";
      let apiName = "";
      switch (this.ai_app_code) {
        // 柳州app
        case "dxlc_lz_app":
          params.businessCode = "1450200";
          apiPath = "./liuzhouGateway";
          apiName = "getQrCode_LIUZHOU";
          break;
        // 柳州小程序
        case "dxlc_lz_wechat":
          params.businessCode = "1450200";
          apiPath = "./liuzhouGateway";
          apiName = "getQrCode_LIUZHOU";
          break;
        // 南通app
        case "cxnt_xh_app":
          params.businessCode = "2320600";
          apiPath = "./nantongGateway";
          apiName = "getQrCode_NANTONG";
          break;
        // 南通小程序
        case "cxnt_xh_wechat":
          params.businessCode = "2320600";
          apiPath = "./nantongGateway";
          apiName = "getQrCode_NANTONG";
          break;
        // 测试用
        case "dxlc_test":
          params.businessCode = "1450200";
          apiPath = "./liuzhouGateway";
          apiName = "getQrCode_LIUZHOU";
          break;
      }
      this.loading = true;
      await Http[apiName](params, apiPath)
        .then(({ res }) => {
          console.log(res);
          // 正常生码
          if (res.code == "SUCCESS" && res.originalData.bizCode == "SUCCESS") {
            this.showQrCodePopup = true;
            this.qrCodeData = res.data.imageData;
            if (res.data.tsmAccId) {
              this.qrCodeNo = res.data.tsmAccId;
            }
          }
          // 未开卡
          else if (res.originalData.bizCode == "NONE_PAY_CARD") {
            // 跳到乘车码
            // 4种场景
            this.jumpToNativeQrCodePage();
          }
          // 生码异常
          else {
            this.$toast("生码异常，请前往处理");
            setTimeout(() => {
              this.jumpToNativeQrCodePage();
            }, 1000);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
      this.loading = false;
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    // 跳转到native/小程序 生码页面
    jumpToNativeQrCodePage: function () {
      if (
        this.ai_app_code == "dxlc_lz_wechat" ||
        this.ai_app_code == "cxnt_xh_wechat" ||
        this.ai_app_code == "dxlc_test"
      ) {
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            wx.miniProgram.postMessage({
              data: {
                type: "go_ride",
              },
            });
            wx.miniProgram.navigateBack({
              delta: 1,
            });
          }
        });
      } else if (
        this.ai_app_code == "dxlc_lz_app" ||
        this.ai_app_code == "cxnt_xh_app"
      ) {
        window.location.href = "liangla://trans";
      }
    },
    // 播放器callback方法
    playerCallback: function (str, detail) {
      console.log(str, detail);
      switch (str) {
        // 播放事件
        case "play":
          this.playingContentIndex = this.currentPlayingContentIndex;
          break;
        case "timeupdate":
          this.playingContentIndex = this.currentPlayingContentIndex;
          break;
        case "paused":
          // 不再对暂停做特殊处理了
          // this.playingContentIndex = -1;
          // this.currentPlayingContentIndex = -1;
          break;
        case "ended":
          this.playingContentIndex = -1;
          this.currentPlayingContentIndex = -1;
          break;
        // 当发现错误时，不再继续播放了
        case "error":
          this.clickStopPlayBtn();
          this.playingContentIndex = -1;
          this.currentPlayingContentIndex = -1;
          this.$toast("播放异常");
          break;
        case "fetch_error":
          this.clickStopPlayBtn();
          this.playingContentIndex = -1;
          this.currentPlayingContentIndex = -1;
          this.$toast("网络异常");
          break;
        case "destroy":
          // 销毁
          this.playingContentIndex = -1;
          this.currentPlayingContentIndex = -1;
          break;
      }
    },
    visibilitychange: function () {
      if (document.hidden) {
        if (this.audioPlayer) {
          this.clickStopPlayBtn();
        }
      }
    },
    // 点击停止播放语音
    clickStopPlayBtn: function () {
      this.audioPlayer.destroy();
      this.audioPlayer = null;
    },
    // 点击播放语音
    clickPlayBtn: async function (index) {
      if (this.audioPlayer) {
        this.clickStopPlayBtn();
      }

      let result = await this.getTTSLimit();
      if (result.code == "SUCCESS") {
        let currentTextLength = this.chatContent[index].answer.length;
        if (currentTextLength > result.remainToken) {
          this.$toast(
            `当前文本长度${currentTextLength},剩余语音播放额度${result.remainToken},无法播放`
          );
          return;
        }
        this.audioPlayer = new AudioPlayer(this.playerCallback, index);
        const au = this.audioPlayer.audio;
        const ctx = this.audioPlayer.audioContext;
        /* ---------- 手势栈内：解锁 + 静音占坑 ---------- */
        await ctx.resume(); // 解锁 Web‑Audio
        au.muted = true; // 静音
        try {
          au.play();
        } catch (_) {} // 在手势中 play，拿到播放许可
        const onCanPlay = () => {
          au.muted = false; // 真正发声
          au.removeEventListener("canplay", onCanPlay);
        };
        au.addEventListener("canplay", onCanPlay);
        this.currentPlayingContentIndex = index;
        this.audioPlayer.loadAudio(
          this.ai_app_code,
          this.$refs["answerText" + index][0].innerText,
          index
        );
      }
      // 达到播放上限  关闭自动播放
      else if (result.code == "TTS_LIMIT") {
        this.$toast("今日语音播放额度已用完，请明日再试");
        this.switchAutoTTS(0);
      }
    },
    // 执行自动播放语音
    autoPlay: async function (index) {
      console.log("执行了自动播放语音");
      this.currentPlayingContentIndex = index;
      let result = await this.getTTSLimit();
      if (result.code == "SUCCESS") {
        this.audioPlayer.autoLoadAudio(
          this.ai_app_code,
          this.conversation_id,
          this.chatContent[index].id
        );
      }
      // 达到播放上限  关闭自动播放
      else if (result.code == "TTS_LIMIT") {
        this.$toast("今日语音播放额度已用完，请明日再试");
        this.switchAutoTTS(0);
      }
    },
    textAreaOnFocus: function () {
      this.textAreaFocus = true;
    },
    textAreaOnBlur: function () {
      this.textAreaFocus = false;
    },
    // 点击了复制按钮
    clickCopyBtn: function (key) {
      copy(this.$refs["answerText" + key][0].innerText);
      Toast("已复制");
    },
    markdownToHtml(markdown) {
      return marked.parse(markdown, { renderer });
    },
    // 开始录音
    startRecord: function () {
      // 如果发现有锁，就返回
      if (this.recordDebounceLock == true) {
        return;
      }
      this.recordDebounceLock = true;
      record.getPermission((permiss) => {
        console.log(permiss);
        if (permiss.status == "fail") {
          this.recordDebounceLock = false;
          Toast("未获取录音权限");
        } else {
          // 停止播放语音
          if (this.audioPlayer) {
            this.clickStopPlayBtn();
          }
          record.startRecorder();
          this.isStopAudioToText = false;
          this.isRecording = true;
          this.second = 0;
          this.dateTimeFormat = "00:00";
          this.recordDebounceLock = false;
          // 开始计时
          this.startTimer();
        }
      });
    },
    // 结束录音
    stopRecord: async function () {
      this.isRecording = false;
      this.stopTimer();
      record.stopRecorder(async (res) => {
        console.log(res);
        if (res) {
          const formData = new FormData();
          formData.append("file", res, "record.mp3");
          formData.append("ai_app_code", this.ai_app_code);
          this.isTranslating = true;
          await Http.audioToText(formData)
            .then(({ res }) => {
              this.isTranslating = false;
              console.log(res);
              if (
                res.code == "SUCCESS" &&
                res.originalData &&
                res.originalData.code == "SUCCESS"
              ) {
                if (!this.isStopAudioToText) {
                  this.inputContent = res.originalData.data.text;
                }
              } else if (res.originalData.code == "CHAT_EXCEPTION") {
                Toast(res.originalData.msg);
              } else {
                Toast("网络异常");
              }
            })
            .catch((err) => {
              this.isTranslating = false;
              console.log(err);
              Toast("网络异常");
            });
        }
      });
    },
    // 停止语音转文字
    stopAudioToText: function () {
      this.isStopAudioToText = true;
      this.isTranslating = false;
    },
    // 开始计时
    startTimer: function () {
      // 开始计时前 先调用一下停止计时 防止有未被销毁的定时器
      this.stopTimer();
      this.timer = setInterval(() => {
        if (this.second >= 60) {
          this.stopRecord();
          Toast("最长支持60秒录音");
        } else {
          this.second = this.second + 1;
          let minute = Math.floor(this.second / 60);
          let second = this.second % 60;
          let minuteFormat = minute > 9 ? minute : "0" + minute;
          let secondFormat = second > 9 ? second : "0" + second;
          this.dateTimeFormat = minuteFormat + ":" + secondFormat;
        }
      }, 1000);
    },
    // 停止计时
    stopTimer: function () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 停止响应
    stopGenerating: async function () {
      this.isGenerating = false;
      this.clickStopPlayBtn();
      let params = {
        task_id: this.task_id,
        ai_app_code: this.ai_app_code,
        requestId: this.requestId,
      };
      if (!this.userId) {
        return;
      }
      await Http.stopGenerating(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.task_id = null;
            this.isGenerating = false;
          } else {
            Toast("网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("网络异常");
        });
    },
    // 获取历史会话详情
    getHistoryMessageDetail: async function () {
      // 如果是新对话，不调接口
      if (this.conversation_id == null) {
        this.chatContentHasMore = false;
        return;
      }
      this.loading = true;
      let params = {
        conversation_id: this.conversation_id,
        ai_app_code: this.ai_app_code,
      };
      if (this.chatContent.length > 0) {
        params.first_id = this.chatContent[0].id;
      }
      await Http.getHistoryMessageDetail(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            if (res.originalData.data.has_more) {
              this.chatContentHasMore = true;
            } else {
              this.chatContentHasMore = false;
            }
            this.chatContentLoading = false;
            // diff接口改了
            let data = cloneDeep(res.originalData.data.data);
            for (let i of data) {
              // 匹配亮啦ceo
              if (this.agentInfo.extraCode == "llceo") {
                i.finishSpecialThink = true;
                i.isSpecialThink = true;
                i.ceoAnimateArr = [];
                i.isFold = true;
                for (let j of this.ceoTextArr) {
                  i.ceoAnimateArr.push({
                    text: j,
                    status: "loadover",
                  });
                }
              }
              // 如果找到了深度思考的抬头和结束符
              if (
                i.answer.indexOf(deepSeekHead) != -1 &&
                i.answer.indexOf(deepSeekFooter) != -1
              ) {
                i.allAnswer = i.answer;
                i.isDeepSeek = true;
                i.isFold = true;
                i.deepSeekAnswer = i.allAnswer.split(deepSeekFooter)[0];
                i.answer = i.allAnswer.split(deepSeekFooter)[1];
                i.finishDeepSeek = true;
              } else if (i.answer.indexOf(deepSeekHead) != -1) {
                i.allAnswer = i.answer;
                i.isDeepSeek = true;
                i.isFold = true;
                i.deepSeekAnswer = i.answer;
                i.finishDeepSeek = true;
                i.answer = "";
              } else if (i.answer.indexOf(imgContentHead) != -1) {
                i.isImage = true;
              }
              if (i.message_files.length > 0) {
                let message_files = [];
                for (let j of i.message_files) {
                  if (j.belongs_to != "assistant") {
                    message_files.push(j);
                  }
                }
                i.message_files = message_files;
              }
            }

            this.chatContent.unshift(...data);
            if (!params.first_id) {
              this.scrollToBottom(true);
            }
            // 这里遍历一下this.chatContent中的所有的项
            this.$nextTick(async () => {
              // 时间复杂度（n）
              console.log(this.chatContent.length);
              for (let i in this.chatContent) {
                // 找到尚未进行匹配特殊抬头的项
                if (
                  this.chatContent[i].isBusiness === undefined ||
                  this.chatContent[i].isBusiness === null
                ) {
                  // 如果字符串长度还没有特殊抬头的长度要长 直接置为false
                  if (
                    this.chatContent[i].answer.length < specialCodeHead.length
                  ) {
                    this.chatContent[i].isBusiness = false;
                    continue;
                  }
                  let length = specialCodeHead.length;
                  let currentHead = this.chatContent[i].answer.substring(
                    0,
                    length
                  );
                  // 如果匹配到的特殊抬头
                  if (currentHead == specialCodeHead) {
                    this.chatContent[i].isBusiness = true;
                    // let res = await businessCodeMatch(
                    //   this.chatContent[i].answer,
                    //   this.ai_app_code
                    // );
                    // // console.log(res);
                    // // 如果成功
                    // if (res.status == "success") {
                    //   this.chatContent[i].isBusiness = true;
                    //   const targetElement = document.getElementById(
                    //     "answerContent_" + this.chatContent[i].id
                    //   );
                    //   if (targetElement) {
                    //     // 创建 Vue 组件实例并手动挂载
                    //     const instance = new res.DynamicComponent({
                    //       propsData: {
                    //         showQrCode: this.showQrCode,
                    //         showLoading: this.showLoading,
                    //         hideLoading: this.hideLoading,
                    //       },
                    //     }).$mount();
                    //     targetElement.appendChild(instance.$el);
                    //   }
                    // } else if (res.status == "error") {
                    //   this.chatContent[i].isBusiness = true;
                    //   const targetElement = document.getElementById(
                    //     "answerContent_" + this.chatContent[i].id
                    //   );
                    //   if (targetElement) {
                    //     // 创建 Vue 组件实例并手动挂载
                    //     const instance = new res.DynamicComponent({
                    //       propsData: {
                    //         showQrCode: this.showQrCode,
                    //         showLoading: this.showLoading,
                    //         hideLoading: this.hideLoading,
                    //       },
                    //     }).$mount();
                    //     targetElement.appendChild(instance.$el);
                    //   }
                    // }
                  } else {
                    this.chatContent[i].isBusiness = false;
                  }
                }
              }
              this.$forceUpdate();
              setTimeout(() => {
                this.scrollToBottom(true);
              }, 300);
            });
          } else {
            Toast("网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("网络异常");
        });
      this.loading = false;
    },
    // 获取会话名称
    getConversationName: async function () {
      let params = {
        conversation_id: this.conversation_id,
        ai_app_code: this.ai_app_code,
      };
      await Http.getConversationName(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            // 兜底
            if (res.originalData.data && res.originalData.data.name) {
              let name = res.originalData.data.name;
              document.title = name;
              this.assistant_name = name;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
    },
    // 获取开场白
    getPrologue: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
      };
      await Http.getPrologue(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS" && res.originalData.code == "SUCCESS") {
            this.prologue = res.originalData.data.opening_statement;
            this.prologueList = res.originalData.data.suggested_questions;
            //获取到配置的文件可上传类型，文件可上传大小
            if (res.originalData.data.file_upload.allowed_file_types) {
              this.$store.commit(
                "allowedFileTypes",
                res.originalData.data.file_upload.allowed_file_types
              );
            }
            if (res.originalData.data.file_upload.fileUploadConfig) {
              this.$store.commit(
                "fileUploadConfig",
                res.originalData.data.file_upload.fileUploadConfig
              );
            }
            //设置文件可上传数量
            if (res.originalData.data.file_upload.number_limits) {
              this.$store.commit(
                "maxUploadCnt",
                res.originalData.data.file_upload.number_limits
              );
              this.maxUploadCnt =
                res.originalData.data.file_upload.number_limits;
            }
            //是否允许文件上传
            if (
              res.originalData.data.file_upload.enabled &&
              res.originalData.data.file_upload.number_limits > 0
            ) {
              this.showFileUpload = true;
            }
            // 用户inputs输入数据
            if (res.originalData.data.user_input_form) {
              let user_input_form = [];
              for (let i of res.originalData.data.user_input_form) {
                if (i["text-input"]) {
                  let obj = i["text-input"];
                  obj.type == "text-input";
                  obj.value = null;
                  user_input_form.push(obj);
                } else if (i["select"]) {
                  let obj = i["select"];
                  obj.type == "select";
                  user_input_form.push(obj);
                  obj.showPicker = false;
                  obj.value = null;
                }
              }
              this.user_input_form = user_input_form;
            }
          } else {
            Toast("网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("网络异常");
        });
    },
    // 发送消息
    sendMessage: async function (message) {
      console.log(message);
      // 如果此时正在生成内容，直接toast用户
      if (this.isGenerating) {
        Toast("回复生成中，请稍等");
        return;
      }
      let checkForm = this.checkForm();
      if (checkForm !== true) {
        this.$toast(`请填写${checkForm}`);
        this.show_user_input_form = true;
        return;
      }
      if (this.isVip == false && this.chatDetail.vipOnly) {
        this.showVipOnlyDialog = true;
        return;
      }
      // 如果发现本地没有ws实例
      // 那么就创建一个
      if (!this.ws) {
        let result = await this.createWS();
        // 如果创建失败
        if (!result) {
          Toast("网络异常,连接建立失败");
          return;
        }
      }
      this.requestId = new Date().getTime();
      let params = {
        query: message || this.inputContent,
        ai_app_code: this.ai_app_code,
        clientType: window.localStorage.getItem("clientType_AI"),
        requestId: this.requestId,
        bizSession: localStorage.getItem("sessionId"),
      };
      if (this.nowLocation) {
        params.location = this.nowLocation;
      }
      if (this.chatDetail.inputParam === 1) {
        let obj = {};
        for (let i of this.user_input_form) {
          if (i.value) {
            obj[i.variable] = i.value;
          }
        }
        console.log(obj);
        console.log(JSON.stringify(obj));
        params.inputs = JSON.stringify(obj);
      }
      if (this.conversation_id) {
        params.conversation_id = this.conversation_id;
      }
      //如果存在待上传的文件
      if (this.filesWaitUpload && this.filesWaitUpload.length > 0) {
        params.files = JSON.stringify(this.filesWaitUpload);
      }
      this.showNewChat = false;
      this.suggestedData = [];
      console.log("===params", params);
      if (this.ws.readyState === WebSocket.OPEN) {
        // 手动让textarea失焦
        this.$refs["textarea"].blur();
        this.responseTempStr = "";
        this.isMatchSpecialHead = 0;
        this.ws.send(JSON.stringify(params));
        this.chatDetail.usedCount = this.chatDetail.usedCount + 1;
        this.message_end_error = true;
        this.isGenerating = true;
        let obj = {
          query: message || this.inputContent,
          files: this.completeFiles,
          answer: "",
          deepSeekAnswer: "",
          allAnswer: "",
          isDeepSeek: false,
          isFold: false,
          requestId: this.requestId,
          isImage: false,
          isBusiness: false,
          businessType: null,
          businessContent: null,
        };
        if (this.agentInfo.extraCode == "llceo") {
          this.needPlayCeoAnimation = true;
          this.ceoAnimationPlayOver = false;
          this.ceoAnimationMessageEnd = false;
          obj.finishSpecialThink = false;
          obj.isSpecialThink = true;
          obj.ceoAnimateArr = [];
        }
        this.currentHasAutoPlaying = false;
        this.chatContent.push(obj);
        this.currentQuery = message || this.inputContent;
        this.inputContent = "";
        //清空输入框内的文件
        this.dataFromUpload = [];
        //清空待上传的文件
        this.completeFiles = [];
        this.filesWaitUpload = [];
        // 停止播放上一段语音
        if (this.audioPlayer) {
          this.clickStopPlayBtn();
        }
        if (!this.hideTTSBtn) {
          // 这里立刻创建播放器  ————————————————————————————————
          this.audioPlayer = new AudioPlayer(this.playerCallback);
          const au = this.audioPlayer.audio;
          const ctx = this.audioPlayer.audioContext;
          /* ---------- 手势栈内：解锁 + 静音占坑 ---------- */
          await ctx.resume(); // 解锁 Web‑Audio
          au.muted = true; // 静音
          try {
            au.play();
          } catch (_) {} // 在手势中 play，拿到播放许可
          const onCanPlay = () => {
            au.muted = false; // 真正发声
            au.removeEventListener("canplay", onCanPlay);
          };
          au.addEventListener("canplay", onCanPlay);
        }
        // 结束  ————————————————————————————————
        // 记录本轮提问的自动播放状态
        this.isAutoPlayVoice_current = this.isAutoPlayVoice;
        this.$nextTick(() => {
          lottie.loadAnimation({
            container: document.getElementById("AI_generating"), // the dom element that will contain the animation
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: loadingJSON, // the path to the animation json
          });
          this.isAutoScroll = true;
          this.scrollToBottom(true);
        });
      } else {
        console.log("websocket连接未打开");
      }
    },
    // 创建webSocket
    createWS: async function () {
      return new Promise((resolve, reject) => {
        let url = `${process.env.VUE_APP_WS_HOST}${
          API.question
        }?appId=${window.localStorage.getItem(
          "appId_AI"
        )}&sId=${window.localStorage.getItem("sessionId_AI")}`;
        console.log(url);
        this.ws = new WebSocket(url);
        this.ws.onopen = () => {
          console.log("WebSocket 连接已经建立。");
          resolve(true);
        };
        this.ws.onmessage = async (event) => {
          // 如果此时并不是正常生成内容状态，直接将返回结果舍弃
          if (!this.isGenerating) {
            return;
          }
          let result = JSON.parse(event.data);
          console.log("收到服务器消息：", result);
          // 在最上面判断异常
          if (result.code == "CHAT_EXCEPTION") {
            console.log("服务器异常");
            this.showGeneratingErrorDialog = true;
            this.generatingErrorMsg = result.msg;
            this.stopGenerating();
            return;
          }
          // 如果发现返回的requestId跟当前的requestId不一致  直接舍弃
          if (this.requestId != result.requestId) {
            console.log("requestId不一致，舍弃");
            return;
          }
          // 收到回复
          if (result.event == "message") {
            this.message_end_error = false;
            if (this.agentInfo.extraCode == "llceo") {
              if (this.needPlayCeoAnimation) {
                this.playCeoAnimation(result);
                this.needPlayCeoAnimation = false;
              }
              if (this.ceoAnimationPlayOver == false) {
                this.responseTempStr = this.responseTempStr + result.answer;
                return;
              }
            }
            this.onMessage(result);
          } else if (result.event == "modal_card") {
            console.log("modal_card", result);
            this.modal_card = result;
          }
          // 结束回复
          else if (result.event == "message_end") {
            if (this.agentInfo.extraCode == "llceo") {
              if (this.ceoAnimationPlayOver == false) {
                this.ceoAnimationMessageEnd = true;
                return;
              }
            }
            this.messageEnd(result);
          }
        };
        this.ws.onerror = (event) => {
          console.error("WebSocket 连接出现错误：", event);
          this.ws = null;
          reject(false);
        };
        this.ws.onclose = (event) => {
          console.log("WebSocket 连接已经关闭。", event);
          this.ws = null;
          reject(false);
        };
      }).catch((err) => {
        console.log(err);
        return false;
      });
    },
    onMessage: function (result) {
      // 如果当前尚未开始匹配或已经匹配成功
      if (
        this.isMatchSpecialHead == 0 ||
        this.isMatchSpecialHead == 1 ||
        this.isMatchSpecialHead == 2 ||
        this.isMatchSpecialHead == 3
      ) {
        this.responseTempStr = this.responseTempStr + result.answer;
      }
      // 如果当前状态是尚未匹配
      if (this.isMatchSpecialHead == 0) {
        // console.log("当前状态是未匹配");
        // console.log(this.responseTempStr);
        // 业务编码是否匹配失败
        let specialCodeCheckFail = false;
        let deepSeekCheckFail = false;
        let imgContentCheckFail = false;
        //  两种情况都要匹配
        // 先匹配是不是深度思考的特殊抬头
        if (this.responseTempStr.length >= deepSeekHead.length) {
          let length = deepSeekHead.length;
          let currentHead = this.responseTempStr.substring(0, length);
          if (currentHead == deepSeekHead) {
            // 匹配成功  深度思考
            // console.log("匹配成功，深度思考");
            this.isMatchSpecialHead = 2;
          } else {
            // console.log("匹配失败，深度思考");
            deepSeekCheckFail = true;
          }
        }
        // 在匹配图片的特殊抬头
        if (this.responseTempStr.length >= imgContentHead.length) {
          let length = imgContentHead.length;
          let currentHead = this.responseTempStr.substring(0, length);
          if (currentHead == imgContentHead) {
            // 匹配成功 图片
            this.isMatchSpecialHead = 3;
          } else {
            imgContentCheckFail = true;
          }
        }
        // 在匹配业务编码的特殊抬头
        if (this.responseTempStr.length >= specialCodeHead.length) {
          // 开始查询是否匹配成功
          let length = specialCodeHead.length;
          let currentHead = this.responseTempStr.substring(0, length);
          if (currentHead == specialCodeHead) {
            // 匹配成功  业务编码
            // console.log("匹配成功，业务编码");
            this.isMatchSpecialHead = 1;
          } else {
            // console.log("匹配失败，业务编码");
            specialCodeCheckFail = true;
          }
        }
        if (specialCodeCheckFail && deepSeekCheckFail && imgContentCheckFail) {
          // 匹配失败
          this.isMatchSpecialHead = 99;
        }
      }
      // 如果匹配到了  业务编码特殊抬头
      if (this.isMatchSpecialHead == 1) {
        // 这里不做任何操作 等待message_end  在message_end生命周期中渲染dom
        // console.log("匹配到了特殊抬头");
      }
      // 如果匹配到了  深度思考 特殊抬头
      else if (this.isMatchSpecialHead == 2) {
        // console.log("匹配到了深度思考");
        let answer = this.responseTempStr || result.answer;
        // 这里要判断下  深度思考 是否思考完毕
        this.responseTempStr = "";
        this.insertDeepSeekAnswer(
          result.conversation_id,
          result.message_id,
          answer
        );
        this.task_id = result.task_id;
        // this.scrollToBottom(false);
      }
      // 如果匹配到了图片
      else if (this.isMatchSpecialHead == 3) {
        let answer = this.responseTempStr || result.answer;
        this.responseTempStr = "";
        this.insertAnswer(result.conversation_id, result.message_id, answer);
        this.task_id = result.task_id;
      }
      // 如果没匹配到
      else if (this.isMatchSpecialHead == 99) {
        let answer = this.responseTempStr || result.answer;
        this.responseTempStr = "";
        this.insertAnswer(result.conversation_id, result.message_id, answer);
        this.task_id = result.task_id;
        // this.scrollToBottom(false);
      }
    },
    messageEnd: async function (result) {
      this.isGenerating = false;
      this.task_id = null;
      if (this.message_end_error) {
        Toast("我溜号了，等会再来找我吧");
        return;
      }
      // 结束回复时，如果chatContent中只有一个值，并且是新对话  代表是首次回复，这时候取一下name
      if (
        this.newChatInfo &&
        this.ai_app_code == this.newChatInfo.ai_app_code &&
        this.chatContent.length == 1
      ) {
        this.getConversationName();
      }
      // 结束的时候 再看一下临时字符串的长度是否小于特殊抬头的长度  如果小于，直接渲染结果
      if (
        this.responseTempStr.length < specialCodeHead.length &&
        this.isMatchSpecialHead == 0
      ) {
        let answer = this.responseTempStr;
        this.responseTempStr = "";
        this.insertAnswer(result.conversation_id, result.message_id, answer);
        this.task_id = result.task_id;
        // this.scrollToBottom(false);
        return;
      }
      // 仅在正常文本回复后  才获取提示语
      if (this.isMatchSpecialHead == 1) {
        // 这里开始匹配具体的业务编码 生成dom
        // 调用封装方法
        console.log("消息结束，匹配到了特殊抬头");
        console.log(this.responseTempStr);
        let res = await businessCodeMatch(
          this.responseTempStr,
          this.ai_app_code
        );
        console.log(res);
        // 如果成功
        if (res.status == "success" || res.status == "error") {
          console.log(result.message_id);
          // this.insertBusinessAnswer(result.conversation_id, result.message_id);
          // 这里强制渲染一下  有点问题
          // this.$forceUpdate();
          console.log(this.modal_card);

          if (this.modal_card) {
            // 如果当前不存在conversation_id
            if (this.conversation_id == null) {
              this.conversation_id = result.conversation_id;
              // 复制当前的query对象
              const newQuery = { ...this.$route.query };
              newQuery.conversation_id = this.conversation_id;
              // 替换路由，保留其他参数
              this.$router.replace({
                name: "ChatDetailPage",
                query: newQuery,
              });
            }
            let modal_card = this.modal_card.modal_card;
            if (modal_card.bizCode == "BIZ_SESSION_INVALID") {
              // 当 bizSessionId 失效时，可以在这里拦截做处理
              // 暂定  目前暂不做任何处理
            }
            this.chatContent[this.chatContent.length - 1].isBusiness = true;
            this.chatContent[this.chatContent.length - 1].businessType =
              modal_card.type;
            this.chatContent[this.chatContent.length - 1].businessContent =
              modal_card;
            this.chatContent[this.chatContent.length - 1].modal_card =
              modal_card;
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToBottom(true);
            }, 100);
          });
        }
      } else {
        // 先立即滚动至底部
        this.$nextTick(() => {
          this.scrollToBottom(true);
        });
        // 结束回复时，获取提示语
        this.getSuggested();
      }
    },
    // 向chatContent中插入回复
    insertAnswer: function (conversation_id, message_id, answer) {
      let resultAnswer = answer;
      // 如果此时没有conversation_id 那么代表这是一个新的对话
      if (this.conversation_id == null) {
        this.conversation_id = conversation_id;
        this.$router.replace({
          name: "ChatDetailPage",
          query: {
            ai_app_code: this.ai_app_code,
            name: this.name,
            conversation_id: conversation_id,
            noChangeName: true,
          },
        });
      }
      // 如果传入的conversation_id跟当前的conversation_id不同的话，直接舍弃
      if (conversation_id != this.conversation_id) {
        console.log("传入的conversation_id跟当前的conversation_id不同");
        return;
      }
      // 先找角标
      let index = -1;
      // 从数组中找到message_id对应的下标  这里效率有点低
      for (let i in this.chatContent) {
        // 如果找到了  直接往对应的回复中添加新的回复
        if (this.chatContent[i].id === message_id) {
          index = i;
          this.chatContent[i].answer =
            this.chatContent[i].answer + resultAnswer;
        }
      }

      // 如果没找到  并且 最后一个 chatContent的值中没有Id  那就插到最后一个
      if (index == -1 && !this.chatContent[this.chatContent.length - 1].id) {
        index = this.chatContent.length - 1;
        this.chatContent[this.chatContent.length - 1].id = message_id;
        this.chatContent[this.chatContent.length - 1].answer = resultAnswer;
        this.chatContent[this.chatContent.length - 1].isBusiness = false;
        if (this.isMatchSpecialHead === 3) {
          this.chatContent[index].isImage = true;
        }
      }
      // 如果当前尚未播放语音
      if (
        this.playingContentIndex == -1 &&
        this.currentHasAutoPlaying == false
      ) {
        // 如果允许自动播放
        if (this.isAutoPlayVoice_current) {
          if (this.isMatchSpecialHead === 3) {
            console.log("该条是图片，不触发自动播放");
            return;
          } else {
            this.currentHasAutoPlaying = true;
            this.autoPlay(index);
          }
        }
      }
      this.scrollToBottom(false);
    },
    // 插入特殊回复(业务编码)
    insertBusinessAnswer: function (conversation_id, message_id) {
      // 如果此时没有conversation_id 那么代表这是一个新的对话
      if (this.conversation_id == null) {
        this.conversation_id = conversation_id;
        this.$router.replace({
          name: "ChatDetailPage",
          query: {
            ai_app_code: this.ai_app_code,
            name: this.name,
            conversation_id: conversation_id,
            noChangeName: true,
          },
        });
      }
      // 直接插到最后一个就行
      this.chatContent[this.chatContent.length - 1].id = message_id;
      this.chatContent[this.chatContent.length - 1].answer = "";
      this.chatContent[this.chatContent.length - 1].isBusiness = true;
    },
    // 插入特殊回复（深度思考）
    insertDeepSeekAnswer: function (conversation_id, message_id, answer) {
      // 如果此时没有conversation_id 那么代表这是一个新的对话
      if (this.conversation_id == null) {
        this.conversation_id = conversation_id;
        this.$router.replace({
          name: "ChatDetailPage",
          query: {
            ai_app_code: this.ai_app_code,
            name: this.name,
            conversation_id: conversation_id,
            noChangeName: true,
          },
        });
      }
      // 如果传入的conversation_id跟当前的conversation_id不同的话，直接舍弃
      if (conversation_id != this.conversation_id) {
        console.log("传入的conversation_id跟当前的conversation_id不同");
        return;
      }
      // 先找角标
      let index = -1;
      // 从数组中找到message_id对应的下标  这里效率有点低
      for (let i in this.chatContent) {
        if (this.chatContent[i].id === message_id) {
          index = i;
          break;
        }
      }
      // 如果没找到  并且 最后一个 chatContent的值中没有Id  那就插到最后一个
      if (index == -1 && !this.chatContent[this.chatContent.length - 1].id) {
        index = this.chatContent.length - 1;
        // 初始化
        this.chatContent[index].answer = "";
        this.chatContent[index].allAnswer = "";
        this.chatContent[index].deepSeekAnswer = "";
        this.chatContent[index].id = message_id;
        this.chatContent[index].isBusiness = false;
        this.chatContent[index].isFold = false;
        this.chatContent[index].finishDeepSeek = false;
        this.chatContent[index].isDeepSeek = true;
      }
      this.chatContent[index].allAnswer =
        this.chatContent[index].allAnswer + answer;
      let allAnswer = this.chatContent[index].allAnswer;
      let normalAnswer = "";
      let deepSeekAnswer = "";
      // 如果找到了结束符
      if (allAnswer.indexOf(deepSeekFooter) != -1) {
        deepSeekAnswer = allAnswer.split(deepSeekFooter)[0];
        normalAnswer = allAnswer.split(deepSeekFooter)[1];
        this.chatContent[index].finishDeepSeek = true;
      } else {
        deepSeekAnswer = allAnswer;
      }
      this.chatContent[index].answer = normalAnswer;
      this.chatContent[index].deepSeekAnswer = deepSeekAnswer;
      // 如果当前尚未播放语音
      if (
        this.playingContentIndex == -1 &&
        this.currentHasAutoPlaying == false
      ) {
        // 如果允许自动播放
        if (this.isAutoPlayVoice_current) {
          this.currentHasAutoPlaying = true;
          this.autoPlay(index);
        }
      }
      this.scrollToBottom(false);
    },
    // 折叠思考内容
    foldThinkingContent: function (index) {
      this.chatContent[index].isFold = !this.chatContent[index].isFold;
    },
    // 停止自动滚动
    stopAutoScroll: function () {
      this.isAutoScroll = false;
    },
    // 移动滚动条到底部  conversationList
    // force 是否是强制移动
    scrollToBottom: function (isForce) {
      // console.log("执行scrollToBottom", this.isAutoScroll, isForce);
      // 如果当前不是自动滚动模式 并且 本次滚动不是强制滚动
      if (!this.isAutoScroll && !isForce) {
        // 直接返回
        return;
      }
      // 如果是强制滚动
      if (isForce) {
        this.$nextTick(() => {
          this.$refs["conversationContent"].scrollIntoView({
            behavior: "smooth",
            block: "end", // 重点：让它对齐到底部
          });
        });
      } else {
        if (this.waitScroll) {
          return;
        }
        this.waitScroll = true;
        // 500毫秒后执行滚动
        setTimeout(() => {
          this.$refs["conversationContent"].scrollIntoView({
            behavior: "smooth",
            block: "end", // 重点：让它对齐到底部
          });
          this.waitScroll = false;
        }, 500);
      }
    },
    // 跳转到设置页面
    jumpToSettingPage: function () {
      // 如果有新对话 并且当前的code不等于新对话的code
      // 或者没有新对话  默认都能进设置页面
      // 云飞说  如果没配新对话 会默认把用户所有的历史新对话都删除
      if (
        (this.newChatInfo &&
          this.ai_app_code != this.newChatInfo.ai_app_code) ||
        !this.newChatInfo
      ) {
        this.$router.push({
          name: "AgentSettingPage",
          query: {
            assistant_name: this.assistant_name,
            ai_app_code: this.ai_app_code,
            conversation_id: this.conversation_id,
          },
        });
      }
    },
    // 获取提示语
    getSuggested: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
        message_id: this.chatContent[this.chatContent.length - 1].id,
      };
      await Http.getSuggested(params)
        .then(({ res }) => {
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            // 返回的时候 如果发现此时正在生成中，那么直接弃掉这个结果
            if (this.isGenerating) {
              return;
            }
            this.suggestedData = res.originalData.data.data;
            // 只有当返回了结果，并且结果大于0时，才进行滚动
            if (this.suggestedData.length > 0) {
              this.scrollToBottom(true);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击提示语
    clickSuggested: function (str) {
      this.sendMessage(str);
    },
    // 根据ai_app_code查询是否存在会话
    findConversation: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
      };
      let result = await Http.findConversation(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            return res.originalData.data;
          } else {
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
          return false;
        });
      return result;
    },
    // 添加发现内容
    addFindAgent: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
      };
      this.loading = true;
      let result = await Http.addAgent(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
          return false;
        });
      this.loading = false;
      return result;
    },
    // 列表滚动方法
    contentOnScroll: function (e) {
      if (
        e.target.scrollHeight - e.target.scrollTop >
        e.target.offsetHeight * 1.3
      ) {
        // 显示箭头
        // console.log("显示箭头");
        this.ShowScrollToBottomBtn = true;
      } else {
        // 隐藏箭头
        // console.log("隐藏箭头");
        this.ShowScrollToBottomBtn = false;
      }
    },
    //接收子组件（文件上传控件）传值，文件上传数据
    sendFilesData(data) {
      this.dataFromUpload = data;
      //会将会话框区域增高，设置滑动到底部
      this.$nextTick(() => {
        this.scrollToBottom(true);
      });
    },
    //接收子组件（文件预览控件）传值，待与会话一起上传的文件
    sendFilesWaitUpload(data, completeFiles) {
      this.filesWaitUpload = data;
      this.completeFiles = completeFiles;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./ChatDetailPage.scss";
</style>
